<script>
    import { fly } from "svelte/transition";
    import { Loading, Button } from "../index";

    let show = false;
    let inline = false;
    let trans = true;
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Button
            on:click={() => {
                show = true;
                setTimeout(()=>{
                    show = false;
                },1000*3)
            }}>基础用法</Button
        >
    </div>
    <h4 class="example-title">内联使用</h4>
    <div class="example-body">
        <Button
            on:click={() => {
                show = true;
                inline = true;
                setTimeout(()=>{
                    show = false;
                    inline = false;
                },1000*3)
            }}>内联使用</Button
        >
    </div>
    <h4 class="example-title">背景不透明</h4>
    <div class="example-body">
        <Button
            on:click={() => {
                show = true;
                trans = false;
                setTimeout(()=>{
                    show = false;
                    trans = true;
                },1000*3)
            }}>背景不透明</Button
        >
    </div>
    <Loading {show} {inline} isTransparent={trans} />
</div>

<style lang="less">
    @import "./example.less";
    .rect {
        background: #eee;
        width: 40px;
        height: 40px;
        display: block;
        border-radius: 8px;
    }
</style>
